export default{
    // URL
    baseURL:'https://api.lanjingshuzi.com/',
    // 1.管理员
    login:'api/ad/oauth/token',// 获取登录的token
    articles:'api/ad/articles',// 文章添加的功能
    getDemands:'api/ad/demands',//查看客户需求列表
    getProblem:`api/problem/types`,//查看问答分类列表
    thoreGetProblem:`api/problem/types`,//客户查看问答分类列表
    thoreGetProblems:`api/problems`,//客户查看问答列表
    addProblem:`api/ad/problems`,//添加问答
    lookProblem:(val)=>{//查看问答列表
        return `api/problems?problem_type_id=${val}`
    },
    reactProblem:(val)=>{//修改问答列表
        return `api/ad/problems/${val}`
    },
    deleteProblem:(val)=>{//删除问答
        return `api/ad/problems/${val}`
    },
    changearticles:(val)=>{
        return `api/ad/articles/${val}/_update`// 文章修改的功能
    },
    deletearticles:'api/ad/articles/_delete',// 文章删除的功能 
    changeArtimcl:(num)=>{
        return `api/ad/articles/${num}/_update`
    },//文章修改功能
    articlesList:'api/ad/articles',// 查看文章列表 
    users:'api/ad/users/current',//查看当前登录用户信息
    summaries:'api/ad/summaries',//查看首页概述汇总
    addBanner:'api/ad/rotation/charts',//添加首页Banner
    getBanner:'api/rotation/charts?role=0',//查看首页Banner
    changeBanner:(id)=>{
        return `api/ad/rotation/charts/${id}/_update`},//修改首页banner
    Dodemands:`api/ad/demands/_`,//处理需求    
    deleteDodemands:`api/ad/demands/_delete`,//删除需求
    getDpList:(id)=>{
        return `api/ad/shops/${id}`
    },//管理员查看店铺的详情
    deleteOss:(id)=>{
        return `api/ad/file/${id}/_delete`
    },//删除OSS文件和file记录
    // 2.商品功能
    getSignature:'api/ad/aliOss/signature',//获取文件上传oss文件的signature
    lookcommodities:'api/ad/commodities',//查看商品列表
    commodities:'api/ad/commodities',// 添加商品
    changecommodities:(id)=>{//修改商品
        return `api/ad/commodities/${id}/_update`
    },
    commodtiesDelete:'api/ad/commodities/_delete',//删除商品信息
    commoditiesList:'api/ad/commodities',//查看商品一级列表
    commoditiesList2:(val)=>{//查看商品的二级列表
        return `api/commodity/types?commodity_type_id=${val}`
    },
    commoditiesList3:(val)=>{//查看商品列表
        return `api/ad/commodities?commodityTypeId=${val}`
    },
    addCommod:`api/ad/commodity/types`,//添加商品分类
    deleteCommod:(num)=>{
        return `api/ad/commodity/types/${num}`//删除商品分类
    },
    changeCommodties:(num)=>{
        return `api/ad/commodity/types/${num}/_update`//修改商品分类
    },
    signature:(name)=>{
        return `api/ad/aliOss/signature?bucket=public&scene=commodity&type=image&fileName=${name}`// 获取文件上传oss文件的signature
    },
    upEXCEL:`api/ad/commodities/_imports`,//Excel导入商品
    colorBlock:`api/ad/color/block`,//添加色块信息
    redColorBlock:(id)=>{
        return `api/ad/color/block/${id}/_update`//修改色块信息
    },
    deleteColorBlock:(id)=>{
        return `api/ad/color/block/${id}`//删除色块信息
    },
    reacdColor:(id)=>{
        return `api/ad/color/block/${id}`//查看色块信息
    },
    //店铺功能
    shop:`api/ad/shops`,
    getShop:`api/ad/shops`,//查看店铺列表
    changeShop:(id)=>{//修改店铺信息
        return `api/ad/shops/${id}/_update`
    },
    shopDelete:`api/ad/shops/_delete`,//删除店铺信息
    //3.客户功能
    demands:'api/demands',//客户添加需求
    lookArticl:`api/articles`,//客户查看文章
    lookArticlad:`api/ad/articles`,//客户查看文章
    lookArticlType:(num)=>{
        return `api/cu/articles/${num}`//客户查看文章详情`
    },
    lookCom:`api/cu/commodities`,//客户查看商品列表
    lookCommite:(num)=>{
        return `api/cu/commodities?commodityTypeId=${num}`//客户查看二级分类下的商品
    },
    lookComm:(num)=>{
        return `api/cu/commodities/${num}`//查看商品详情
    },
    lookStore:`api/cu/shops`,//查看店铺列表
    lookStoreN:(num)=>{
        return `api/cu/shops/${num}`//查看店铺详情
    },
    // glookBanner:`api/rotation/charts`,//查看店铺banner
}


// WEBPACK FOOTER //
// ./src/axios/api.js